// extracted by mini-css-extract-plugin
module.exports = {"container":"intro-module--container--2kPCw","box":"intro-module--box--27KPq","new":"intro-module--new--1FaqY"};